import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import SEO from "../../components/Seo"
import Layout from "../../components/Layout"
import Hero from "../../components/Careers/Posicion/Hero"
import InfoPosicion from "../../components/Careers/Posicion/InfoPosicion"
import Form from "./Form"
import { postPosition, getPositionDetails } from "../../core/services/careers/positions"

const Positions = ({ pageContext }) => {
  const [fullName, setFullName] = useState(null)
  const [email, setEmail] = useState(null)
  const [linkedin, setLinkedin] = useState(null)
  const [resume, setResume] = useState("")
  const [message, setMessage] = useState(null)
  const [isSentForm, setIsSentForm] = useState(false)
  const [jobDetail, setJobDetail] = useState()
  const [loading, setLoading] = useState(false)

  const id = pageContext.slug

  useEffect(() => {
    async function fetchData() {
      const jobDetail = await getPositionDetails(id)
      setJobDetail(jobDetail)
    }
    fetchData()    
  },[id]);

  const handleSubmit = async evt => {
    evt.preventDefault()
    setLoading(true)

    try {
      const formData = new FormData()
      formData.append("full_name", fullName)
      formData.append("email", email)
      formData.append("resume", resume)
      formData.append("linkedin", linkedin)
      await postPosition(id, formData)
      setIsSentForm(true)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const handleChangeUploadResume = evt => {
    const file = evt.target.files[0]
    setResume(file)
  }

  return (
    <Layout>
      <SEO title={jobDetail?.data.position_name} />
      <Hero position_name={jobDetail?.data.position_name} location_display={jobDetail?.data.location_display} />
      <InfoPosicion description={jobDetail?.data.description} />
      <section className="bg-primary py-20 text-white">
        <div className="container mx-auto px-6">        
          <h3 className="text-5xl pb-12">Join us</h3>
          {isSentForm ? (
            <div className="text-center text-2xl h-80 pt-24">Formulario enviado exitosamente !!</div>
          ) : (
            <Form
              handleSubmit={handleSubmit}
              fullName={fullName}
              setFullName={setFullName}
              email={email}
              setEmail={setEmail}
              linkedin={linkedin}
              setLinkedin={setLinkedin}
              handleChangeUploadResume={handleChangeUploadResume}
              message={message}
              setMessage={setMessage}
              loading={loading}
            />
          )}
        </div>
      </section>
    </Layout>
  )
}

export default Positions

Positions.propTypes = {
  pageContext: PropTypes.shape({
    id: PropTypes.number,
  }),
}
